module.exports = __webpack_public_path__ + "img/img_bg_i3_right.c356b7f3.png";